import planModel from "src/models/plan"
import resourceModel from "src/models/resource"
import resourceTypeModel from "src/models/resourceType"
import eventModel from "src/models/event"
import eventTypeModel from "src/models/eventType"
import planTypeModel from "src/models/planType"
import constraintModel from "src/models/constraint"

export default function getGenderByModelName(modelName) {
  switch (modelName) {
    // case someModel.name:
    //   return `feminine`
    case resourceModel.name:
    case resourceTypeModel.name:
    case eventTypeModel.name:
    case planModel.name:
    case planTypeModel.name:
      return `masculine`
    case eventModel.name:
    case constraintModel().name:
      return `neuter`
    default:
      return null
  }
}
